//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "integral-rule",
    data() {
        return {}
    },
    methods: {},
}
